import React from "react";
import { ReactComponent as ButtonArrow } from "../../../Assets/Images/Button/btn_arrow.svg";

const CustomButton = ({
    href,
    text,
    className = "",
    target = "_self",
    onClick,
    type = "button", // add type for form buttons
    isLoading = false,
}) => {
    if (!text) return null;

    if (href) {
        // Renders as a link
        return (
            <a
                href={href}
                target={target}
                onClick={onClick}
                className={`customs_btn ${className}`}
            >
                {text} <span><ButtonArrow /></span>
            </a>
        );
    }

    // Renders as a button
    return (
        <button
            type={type}
            onClick={onClick}
            className={`customs_btn ${className}`}
            disabled={isLoading}
        >
            {isLoading ? "Loading..." : text} <span><ButtonArrow /></span>
        </button>
    );
};

export default CustomButton;
